<template>
  <div class='container'>
    <div
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="scrollDisabled"
      infinite-scroll-immediate-check="false">
        <div class="presell">
          <head-line line-text="预售商品"></head-line>
          <div class="presell_item" v-for="(item, index) in dataList" :key="index">
              <div class="presell_img">
                <img :src="item.FPicUrl" alt=""/>
              </div>
              <div class="presell_info flex">
                <div class="info_msg">
                  <div class="title">{{item.FTitle}}</div>
                  <div class="price flex">
                    <div class="tig">到手价</div>
                    <div class="bargin">
                      <span>￥</span>{{item.FShowPrice}}
                    </div>
                    <div class="origin_price">原价 <span>￥{{item.FPrice}}</span></div>
                  </div>
                </div>
              <div class="decorate flex">
                <div class="like">
                  <span class="iconfont icon-xin" :class="[item.FIsReserve ? 't_20a0ff' : '']"></span>{{item.FReserveCount | countFilter}}人想要
                </div>
                <mt-button
                  class="btn"
                  :class="[item.FIsReserve ? 'reserve' : '']"
                  type="default"
                  @click="formSubmitReserve(index, item.Fid)"
                  :disabled="reserveLoading[index]">{{item.FIsReserve ? '取消预定' : '立即预定'}}
                </mt-button>
              </div>
            </div>
          </div>
        </div>
        <!-- no more -->
        <segement-Line
          v-if="!haveMore"
          line-text="没有更多商品了">
        </segement-Line>
        <segement-Line
          v-else
          :is-load="true">
        </segement-Line>
        <!-- 返回顶部 -->
        <quick-top @returnTop="returnTop" :isReturn="isReturn"></quick-top>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import SegementLine from '@/components/puppetComponent/SegementLine'
import HeadLine from '@/components/puppetComponent/HeadLine'
import QuickTop from '@/components/smartComponent/QuickTop'
import { Toast, Indicator } from 'mint-ui'
import {
  PresellApi,
  PresellNoLoginApi,
  PresellReserveAdd,
  PresellReserveCancel
} from '@/api/presellGood'

export default {
  data () {
    return {
      haveMore: true,
      scrollDisabled: false,
      currentIndex: 0,
      dataList: [],
      isReturn: false,
      isLastOne: false,
      // 预定loading
      reserveLoading: []
    }
  },
  computed: {
    ...mapGetters([
      'loginState',
      'getIsApp',
      'getIsAuthorized'
    ])
  },
  mounted () {
    this.fetchData()
    // 绑定监听事件
    this.container = document.getElementsByClassName('container')[0]
    this.container.addEventListener('scroll', this.handleScroll)
  },
  components: {
    SegementLine,
    HeadLine,
    QuickTop
  },
  methods: {
    ...mapMutations([
      'AUTHORIZE_POPUP_SHOW'
    ]),
    fetchData (isDropDown = false) {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      let params = {
        DropDown: isDropDown
      }
      this.scrollDisabled = true
      if (this.loginState) {
        PresellApi(params).then(res => {
          Indicator.close()
          this.scrollDisabled = false
          this.setResData(res)
        }).catch(err => {
          Indicator.close()
          this.haveMore = false
          Toast(err.ErrMsg)
        })
      } else {
        PresellNoLoginApi(params).then(res => {
          Indicator.close()
          this.scrollDisabled = false
          this.setResData(res)
        }).catch(err => {
          Indicator.close()
          this.haveMore = false
          Toast(err.ErrMsg)
        })
      }
    },
    setResData (res) {
      this.dataList = [...this.dataList, ...res.DataList]
      this.isLastOne = res.IsEnd
      if (res.IsEnd) {
        this.haveMore = false
      } else {
        this.haveMore = true
      }
    },
    // 预定
    presellReserveApi (index, fid) {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      let FIsReserve = this.dataList[index].FIsReserve
      let params = { fid: fid }
      if (!FIsReserve) {
        PresellReserveAdd(params).then(res => {
          Indicator.close()
          this.setPresellResData(index, FIsReserve)
        }).catch(err => {
          Indicator.close()
          this.haveMore = false
          Toast(err.ErrMsg)
        })
      } else {
        PresellReserveCancel(params).then(res => {
          Indicator.close()
          this.setPresellResData(index, FIsReserve)
        }).catch(err => {
          Indicator.close()
          this.haveMore = false
          Toast(err.ErrMsg)
        })
      }
      this.reserveLoading[index] = false
    },
    setPresellResData (index, FIsReserve) {
      let tigInfo = ''
      let icon = ''
      if (FIsReserve) {
        tigInfo = '已取消预定'
        icon = 'iconfont icon-icon_wrong'
      } else {
        tigInfo = '已预定成功'
        icon = 'iconfont icon-icon_right'
      }
      Toast({
        message: tigInfo,
        iconClass: icon
      })
      let FReserveCount = this.dataList[index].FReserveCount
      this.dataList[index]['FIsReserve'] = !FIsReserve
      this.dataList[index]['FReserveCount'] = FIsReserve ? FReserveCount - 1 : FReserveCount + 1
      this.reserveLoading[index] = false
    },
    // 立即预定
    formSubmitReserve (index, fid) {
      if (this.loginState) {
        // TODO:  formId收集
        // 立即/取消预定
        this.presellReserveApi(index, fid)
      } else {
        this.unLoginModal()
      }
    },
    // 未登录检测
    unLoginModal: function () {
      if (!this.getIsAuthorized && this.getIsApp) {
        // 弹出授权登录弹窗
        this.AUTHORIZE_POPUP_SHOW(true)
        return
      }
      if (this.getIsAuthorized && this.getIsApp) {
        this.$store.commit('LOGINDIALOG_SHOW', true)
        return
      }
      this.$store.commit('LOGINDIALOG_SHOW', true)
    },
    // 返回顶部
    returnTop () {
      let container = this.container
      let scrollTop = container.scrollTop
      let timer = setInterval(function () {
        scrollTop -= 100
        if (scrollTop < 100) {
          container.scrollTop = 0
          clearInterval(timer)
        } else {
          container.scrollTop = scrollTop
        }
      }, 30)
    },
    // 滚动监听
    handleScroll (e) {
      // 滚动高度
      let scrollTop = this.container.scrollTop
      // 屏幕高度
      let documentH = document.documentElement.clientHeight || document.body.clientHeight
      if (scrollTop > documentH) {
        this.isReturn = true
      } else {
        this.isReturn = false
      }
    },
    loadMore () {
      let { isLastOne } = this
      if (isLastOne) {
        this.haveMore = false
        return
      }
      this.haveMore = true
      this.fetchData(true)
    }
  },
  filters: {
    countFilter (val) {
      if (val < 10000) {
        return val
      } else {
        return '9999+'
      }
    }
  }
}
</script>

<style scoped>
  .presell_item{
    display: flex;
    padding: 3%;
    box-sizing: border-box;
    background: #fff;
    margin: 3% 0;
  }
  .presell_img{
    display: block;
    margin-right: 3%;
  }
  .presell_item .presell_img img{
    display: block;
    border-radius: 8px;
    width: 7.2em;
    height: 7.2em;
  }
  .presell_info{
    height: 7.2em;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    overflow: hidden;
    word-wrap:break-word;
  }
  .presell_info .title{
    margin-bottom: 2px;
    font-size: 1em;
    max-height: 3em;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient:vertical;
  }
  @media screen and (max-width: 320px) {
    .presell_item .presell_img img{
      display: block;
      border-radius: 8px;
      width: 6em;
      height: 6em;
    }
    .presell_info .title{
      font-size: 0.8em;
    }
    .presell_info{
      height: 6em;
    }
  }
  .price>.tig{
    background: #ffe7bb;
    color: #ff6d2c;
    border:1px solid #ffd8bf;
    border-radius: 5px;
    height: 20px;
    line-height: 20px;
    font-size: 13px;
    padding: 0 3px;
    align-self: center;
    margin-right: 5px;
  }
  .price>.bargin{
    color: red;
    font-size: 14px;
    padding-top: 3px;
  }
  .price>.bargin>span{
    font-size: 14px;
  }
  .price>.origin_price{
    font-size: 12px;
    color: #999;
    margin-left: 6px;
    align-self: center;
    height: 14px;
  }
  .price>.origin_price>span{
    text-decoration: line-through;
  }
  .presell_info .decorate{
    justify-content: space-between;
  }
  .decorate .btn{
    font-size: 0.8em;
    background: red;
    color: #fff;
    height: 2.2em;
    line-height: 2.2em;
    box-sizing: border-box;
    border-radius: 20px;
    margin:0;
    border: none;
    box-shadow: none;
  }
  .decorate .reserve{
    background: #fff;
    color:#000;
    border:1px solid #000;
  }
  .decorate .like{
    color: #999;
    font-size: 13px;
    display: flex;
    align-items: center;
  }
  .decorate .like>text{
    margin-right: 8px;
    vertical-align: middle;
  }
  .flex{
    display: flex;
  }
  .t_20a0ff{
    color: #20a0ff;
  }
</style>
